import { Smartphone } from "lucide-react";

/**
 * Sichtbarer Link zur mobilen App-Vorschau (/expo). Bewusst ein echtes
 * <a href="/expo"> (relativ), damit die Host-Erkennung in dev und prod
 * identisch funktioniert. Wird auf Login/Registrierung sowie in der
 * Abo-Sperre/Paywall genutzt, damit ausgesperrte Nutzer:innen die App
 * trotzdem aufs Handy laden können.
 */
export default function ExpoPreviewLink({
  className = "",
}: {
  className?: string;
}) {
  return (
    <a
      href="/expo"
      className={`flex items-center justify-center gap-2 w-full rounded-xl border border-[var(--color-app-border)] px-4 py-3 text-[14px] font-semibold text-[var(--color-brand-500)] hover:bg-[var(--color-app-bg-elevated,#fff)] transition-colors ${className}`}
      data-testid="link-expo-preview"
    >
      <Smartphone size={18} />
      App auf dem Handy öffnen (Expo Go)
    </a>
  );
}
